import { useNavigate } from "react-router-dom";
import { Screen } from "@/components/kit";
import { DonateStep } from "@/components/DonateStep";
import { useT } from "@/lib/i18n";

export default function DonatePage() {
  const t = useT();
  const nav = useNavigate();
  return (
    <Screen testID="donate-screen" title={t("Donate")} subtitle={t("Keep Fuel Hauler Pro free")}>
      <DonateStep onSkip={() => (window.history.state?.idx > 0 ? nav(-1) : nav("/"))} skipLabel="Not now" onSkipBack />
    </Screen>
  );
}
